/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LogOut: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M8.10254 3.00488C8.60667 3.05621 9 3.48232 9 4C9 4.51768 8.60667 4.94379 8.10254 4.99512L8 5H5V19H8L8.10254 19.0049C8.60667 19.0562 9 19.4823 9 20C9 20.5177 8.60667 20.9438 8.10254 20.9951L8 21H4C3.44772 21 3 20.5523 3 20V4L3.00488 3.89746C3.05621 3.39333 3.48232 3 4 3H8L8.10254 3.00488ZM16.7412 8.34961C17.078 7.95665 17.6532 7.88885 18.0693 8.17773L18.1504 8.24121L21.6504 11.2412C21.872 11.4312 22 11.7081 22 12C22 12.2919 21.872 12.5688 21.6504 12.7588L18.1504 15.7588C17.7311 16.1182 17.1006 16.0697 16.7412 15.6504C16.3818 15.2311 16.4303 14.6006 16.8496 14.2412L18.2979 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H18.2979L16.8496 9.75879L16.7754 9.68848C16.4258 9.32143 16.4042 8.74275 16.7412 8.34961Z'
      fill='currentColor'
    />
  </React.Fragment>
)
